module.exports = __webpack_public_path__ + "img/Logo_Uni_Trier_typo_neg.46368535.svg";